import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { getWithExpiry } from '../../../Domain/Helpers/LocalStorageHelper';
import BonusTagMappingSection from './BonusTagMappingSection';

async function updateQtechProviders(token) {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 5 * 60 * 1000); // 5 min

  try {
    const response = await fetch(`${baseUrl}qtech/update-providers`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({}),
      signal: controller.signal,
    });
    clearTimeout(timeout);
    return await response.json();
  } catch (err) {
    clearTimeout(timeout);
    if (err.name === 'AbortError') throw new Error('Request timed out after 5 minutes');
    throw err;
  }
}

function SettingsPage({ setLoggedIn }) {
  const [loading, setLoading] = useState(false);
  const [result,  setResult]  = useState(null);

  const handleUpdate = async () => {
    const token = getWithExpiry('token');
    if (!token) { setLoggedIn(false); return; }
    setLoading(true);
    setResult(null);
    try {
      const data = await updateQtechProviders(token);
      if (data?.error) {
        toast.error(data.error?.message ?? data.error);
      } else {
        toast.success('QTech providers updated successfully');
        setResult(data?.data ?? data);
      }
    } catch (err) {
      toast.error(err.message ?? 'Update failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="page-header">
        <div>
          <h4 className="page-title">Settings</h4>
          <p className="page-subtitle">System configuration and maintenance actions</p>
        </div>
      </div>

      <div className="card-section">
        <h6 style={{ fontWeight: 700, color: '#2e2e31', marginBottom: 4 }}>Update QTech Providers</h6>
        <p style={{ fontSize: 13, color: '#607d8b', marginBottom: 16 }}>
          Syncs the QTech provider list from the aggregator. This process can take up to 5 minutes — do not close the page while it runs.
        </p>

        <div className="d-flex align-items-center gap-3">
          <button
            className="btn btn-flexpink btn-sm"
            onClick={handleUpdate}
            disabled={loading}
          >
            {loading
              ? <><span className="spinner-border spinner-border-sm me-2" />Updating providers… (may take up to 5 min)</>
              : '↻ Update QTech Providers'
            }
          </button>
          {loading && (
            <span style={{ fontSize: 12, color: '#9ca3af' }}>
              Please wait, this can take a few minutes.
            </span>
          )}
        </div>

        {result && (
          <div className="alert alert-success mt-3 mb-0" role="alert" style={{ fontSize: 13 }}>
            <strong>Done.</strong> Providers updated successfully.
            {typeof result === 'object' && (
              <pre style={{ fontSize: 11, marginTop: 8, marginBottom: 0, background: 'transparent', padding: 0 }}>
                {JSON.stringify(result, null, 2)}
              </pre>
            )}
          </div>
        )}
      </div>

       <BonusTagMappingSection setLoggedIn={setLoggedIn} />
       
    </div>
  );
}

export default SettingsPage;
